module.exports = __webpack_public_path__ + "img/75641.eb5b3644.svg";